var utils = require('./tripletrax.utils.js');

function dataTableMethods() {

    if (!utils.isUndefined($.fn.dataTableExt)) {
        $.fn.dataTableExt.oApi.fnReloadAjax = function (oSettings, sNewSource, fnCallback, bStandingRedraw) {
            if (!utils.isUndefined(sNewSource)) {
                oSettings.sAjaxSource = sNewSource;
            }
            this.oApi._fnProcessingDisplay(oSettings, true);
            var that = this;
            var iStart = oSettings._iDisplayStart;
            var aData = [];

            this.oApi._fnServerParams(oSettings, aData);

            oSettings.fnServerData(oSettings.sAjaxSource, aData, function (json) {
                /* Clear the old information from the table */
                that.oApi._fnClearTable(oSettings);

                /* Got the data - add it to the table */
                var aData = (oSettings.sAjaxDataProp !== "") ?
                     that.oApi._fnGetObjectDataFn(oSettings.sAjaxDataProp)(json) : json;

                for (var i = 0 ; i < aData.length ; i++) {
                    that.oApi._fnAddData(oSettings, aData[i]);
                }

                oSettings.aiDisplay = oSettings.aiDisplayMaster.slice();
                that.fnStandingRedraw(); // edited this line to use this function instead on plain <a href="//legacy.datatables.net/ref#fnDraw">fnDraw</a>
                if (!utils.isUndefined(bStandingRedraw)) {
                    oSettings._iDisplayStart = iStart;
                    that.fnDraw(false);
                }

                that.oApi._fnProcessingDisplay(oSettings, false);

                /* Callback user function - for event handlers etc */
                if (typeof fnCallback == 'function' && fnCallback != null) {
                    fnCallback(oSettings);
                }
            }, oSettings);
        }

        $.fn.dataTableExt.oApi.fnStandingRedraw = function (oSettings) {
            //redraw to account for filtering and sorting
            // concept here is that (for client side) there is a row got inserted at the end (for an add)
            // or when a record was modified it could be in the middle of the table
            // that is probably not supposed to be there - due to filtering / sorting
            // so we need to re process filtering and sorting
            // BUT - if it is server side - then this should be handled by the server - so skip this step
            if (oSettings.oFeatures.bServerSide === false) {
                var before = oSettings._iDisplayStart;
                oSettings.oApi._fnReDraw(oSettings);
                //iDisplayStart has been reset to zero - so lets change it back
                oSettings._iDisplayStart = before;
                oSettings.oApi._fnCalculateEnd(oSettings);
            }

            //draw the 'current' page
            oSettings.oApi._fnDraw(oSettings);
        };

        $.fn.dataTableExt.oApi.fnFilterClear = function (oSettings) {
            var i, iLen;

            /* Remove global filter */
            oSettings.oPreviousSearch.sSearch = "";

            /* Remove the text of the global filter in the input boxes */
            if (!utils.isUndefined(oSettings.aanFeatures.f)) {
                var n = oSettings.aanFeatures.f;
                for (i = 0, iLen = n.length ; i < iLen ; i++) {
                    $('input', n[i]).val('');
                }
            }

            /* Remove the search text for the column filters - NOTE - if you have input boxes for these
             * filters, these will need to be reset
             */
            for (i = 0, iLen = oSettings.aoPreSearchCols.length ; i < iLen ; i++) {
                oSettings.aoPreSearchCols[i].sSearch = "";
            }

            /* Redraw */
            oSettings.oApi._fnReDraw(oSettings);
        };

        $.fn.dataTableExt.afnFiltering.push(
            function (oSettings, aData, iDataIndex) {
                if (oSettings.sTableId === 'table_data_view_properties') {

                    if ($(oSettings.aoData[iDataIndex].nTr).data().hidden) {
                        return false;
                    }
                } else if (oSettings.sTableId === 'table_patient_examination') {

                    if ($('[name="limit_examination_list_completeness_selections"]').is(':checked')) {

                        var selection = $('[name="show_patients_incomplete_course_data_year"]').select2('val');
						if (selection === 'past_year' && moment(aData[1]) >= moment().subtract(1, 'years')) {
							return true;
						} else if (selection === 'current_year' && moment(aData[1]).year() === moment().year()) {
							return true;
						} else if (selection === 'last_year' && moment(aData[1]).year() === moment().year() - 1) {
							return true;
						}

						return false;
					}

				} else if (oSettings.sTableId === 'table_patientlist') {

					var additionalColumns = 0;
					if ($('#locale').data().pseudonymization !== 'none') {
						additionalColumns = 2;
					}

					var searchValue = $('.tt-datatable-patient-search').val();
					if (aData[5 + additionalColumns] !== null && aData[5 + additionalColumns] !== '' && searchValue !== '') {
						// return aData[5 + additionalColumns] === searchValue;
					}

                    if ($('[name="hide_patients_released"]').is(':checked')) {

                        if (aData[7 + additionalColumns] === 1 || aData[7 + additionalColumns] === '1') {
                            return false;
                        } else if (((aData[8 + additionalColumns] === 1 || aData[8 + additionalColumns] === '1') && (utils.isUndefined(aData[10 + additionalColumns]) || aData[10 + additionalColumns] === 0 || aData[10 + additionalColumns] === '0' || aData[10 + additionalColumns] === ''))
                            || ((aData[8 + additionalColumns] === 1 || aData[8 + additionalColumns] === '1') && (aData[10 + additionalColumns] === 1 || aData[10 + additionalColumns] === '1')
                                && (utils.isUndefined(aData[9 + additionalColumns]) || utils.isUndefined(aData[11 + additionalColumns]) || aData[9 + additionalColumns] === '' || aData[11 + additionalColumns] === ''
                                    || utils.stringToDate(aData[9 + additionalColumns]) > utils.stringToDate(aData[11 + additionalColumns])))) {
                            return false;
                        } else if (((aData[12 + additionalColumns] === 1 || aData[12 + additionalColumns] === '1') && (utils.isUndefined(aData[16 + additionalColumns]) || aData[16 + additionalColumns] === 0 || aData[16 + additionalColumns] === '0' || aData[16 + additionalColumns] === ''))
                            || ((aData[12 + additionalColumns] === 1 || aData[12 + additionalColumns] === '1') && (aData[16 + additionalColumns] === 1 || aData[16 + additionalColumns] === '1')
                                && (utils.isUndefined(aData[13 + additionalColumns]) || utils.isUndefined(aData[17 + additionalColumns]) || aData[13 + additionalColumns] === '' || aData[17 + additionalColumns] === ''
                                    || utils.stringToDate(aData[13 + additionalColumns]) > utils.stringToDate(aData[17 + additionalColumns])))) {
                           return false;
                        } else if (((aData[14 + additionalColumns] === 1 || aData[14 + additionalColumns] === '1') && (utils.isUndefined(aData[16 + additionalColumns]) || aData[16 + additionalColumns] === 0 || aData[16 + additionalColumns] === '0' || aData[16 + additionalColumns] === ''))
                            || ((aData[14 + additionalColumns] === 1 || aData[14 + additionalColumns] === '1') && (aData[16 + additionalColumns] === 1 || aData[16 + additionalColumns] === '1')
                                && (utils.isUndefined(aData[15 + additionalColumns]) || utils.isUndefined(aData[17 + additionalColumns]) || aData[15 + additionalColumns] === '' || aData[17 + additionalColumns] === ''
                                    || utils.stringToDate(aData[15 + additionalColumns]) > utils.stringToDate(aData[17 + additionalColumns])))) {
                            return false;
                        } else if (((aData[18 + additionalColumns] === 1 || aData[18 + additionalColumns] === '1') && (utils.isUndefined(aData[16 + additionalColumns]) || aData[16 + additionalColumns] === 0 || aData[16 + additionalColumns] === '0' || aData[16 + additionalColumns] === ''))
                            || ((aData[18 + additionalColumns] === 1 || aData[18 + additionalColumns] === '1') && (aData[16 + additionalColumns] === 1 || aData[16 + additionalColumns] === '1')
                                && (utils.isUndefined(aData[19 + additionalColumns]) || utils.isUndefined(aData[17 + additionalColumns]) || aData[19 + additionalColumns] === '' || aData[17 + additionalColumns] === ''
                                    || utils.stringToDate(aData[19 + additionalColumns]) > utils.stringToDate(aData[17 + additionalColumns])))) {
                            return false;
                        }

                        return true;
                    }
				}

                return true;
            }
        );

        $.fn.dataTable.Api.register('page.jumpToData()', function (data, column) {
            var pos = -1;

            if (this.search() !== '') {
                pos = this.column(column, {order: 'current', search: 'applied'}).data().indexOf(data);
            } else {
                pos = this.column(column, {order: 'current'}).data().indexOf(data);
            }
            if (pos >= 0) {
                var page = Math.floor(pos / this.page.info().length);
                this.page(page).draw(false);
            }
            return this;
        });
    }
}

module.exports.dataTableMethods = dataTableMethods;
